import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.analysis.navigation');
import { Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-component-analysis-navigation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.analysis.navigation/view.scss */
:host {
  display: block;
}

.analysis-site-header {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: stretch;
  min-height: 58px;
  border-bottom: 1px solid #d7dde5;
  background: #fff;
}

.analysis-site-brand {
  display: inline-flex;
  align-items: center;
  padding: 0 24px 0 0;
  color: #244f76;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-decoration: none;
  white-space: nowrap;
}

.analysis-page-navigation {
  display: flex;
  min-width: 0;
  align-items: stretch;
  gap: 28px;
}

.analysis-page-navigation a {
  position: relative;
  display: inline-flex;
  min-height: 58px;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  color: #66717f;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.15s ease;
}

.analysis-page-navigation a::after {
  position: absolute;
  right: 0;
  bottom: -1px;
  left: 0;
  height: 2px;
  background: transparent;
  content: "";
}

.analysis-page-navigation a:hover,
.analysis-page-navigation a:focus-visible,
.analysis-page-navigation a.is-active {
  color: #244f76;
}

.analysis-page-navigation a.is-active::after {
  background: #2b5d87;
}

.analysis-page-navigation a:focus-visible,
.analysis-site-brand:focus-visible {
  border-radius: 3px;
  outline: 2px solid rgba(43, 93, 135, 0.3);
  outline-offset: 3px;
}

.analysis-site-header__meta {
  align-self: center;
  border-radius: 999px;
  background: #eef2f5;
  padding: 6px 12px;
  color: #486176;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

@media (max-width: 1040px) {
  .analysis-site-header {
    grid-template-columns: auto 1fr;
  }
  .analysis-site-header__meta {
    display: none;
  }
  .analysis-page-navigation {
    justify-content: flex-end;
    gap: 18px;
  }
}
@media (max-width: 760px) {
  .analysis-site-header {
    grid-template-columns: 1fr;
    padding-top: 12px;
  }
  .analysis-site-brand {
    min-height: 32px;
    padding: 0;
  }
  .analysis-page-navigation {
    width: 100%;
    justify-content: flex-start;
    gap: 22px;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-width: thin;
  }
  .analysis-page-navigation a {
    min-height: 46px;
  }
}`],
})
export class ComponentAnalysisNavigationComponent implements OnInit, OnDestroy {
    @Input() public current: string = '';
    public activeKey: string = '';
    private navigationSubscription: Subscription | null = null;

    public readonly items = [
        { key: 'specialization', label: '전국 분포', route: '/specialization-distribution', fragment: '', href: '/specialization-distribution' },
        { key: 'dashboard', label: '대시보드', route: '/dashboard', fragment: '', href: '/dashboard' },
        { key: 'regional-analysis', label: '지역 분석', route: '/regional-analysis', fragment: '', href: '/regional-analysis' },
        { key: 'simulator', label: '정책 시뮬레이터', route: '/policy-simulator', fragment: '', href: '/policy-simulator' },
        { key: 'recommendation', label: '정책 추천', route: '/policy-recommendation', fragment: '', href: '/policy-recommendation' },
        { key: 'sources', label: '상태 안내', route: '/data-sources', fragment: '', href: '/data-sources' },
    ];

    constructor(@Inject( Router) private router: Router) { }

    public ngOnInit() {
        this.syncActiveKey(this.router.url);
        this.navigationSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) this.syncActiveKey(event.urlAfterRedirects);
        });
    }

    public ngOnDestroy() {
        this.navigationSubscription?.unsubscribe();
    }

    public activateItem(key: string) {
        this.activeKey = key;
    }

    public isItemActive(key: string): boolean {
        return key === (this.activeKey || this.current);
    }

    public itemClass(key: string): string {
        return this.isItemActive(key) ? 'is-active' : '';
    }

    private syncActiveKey(url: string) {
        const path = url.split(/[?#]/)[0];
        const routeItem = this.items.find(item => item.route === path);
        if (routeItem) {
            this.activeKey = routeItem.key;
            return;
        }
        this.activeKey = this.current;
    }
}

export default ComponentAnalysisNavigationComponent;